// Unresolved requests survive route changes and reloads in this browser tab.
// Bind to the authenticated admin ID; never persist an authentication token.
const KEY = 'voogo.admin.broadcast.pending.v1';
export function clearBroadcastRecovery() {
  try { sessionStorage.removeItem(KEY); } catch { /* No stored recovery is available. */ }
}
export function readBroadcastRecovery(accountId) {
  try {
    const saved = JSON.parse(sessionStorage.getItem(KEY) || 'null');
    if (!saved) return null;
    if (!accountId || saved.accountId !== String(accountId) || !saved.request?.idempotency_key || !saved.request?.preview_token) {
      clearBroadcastRecovery(); return null;
    }
    return saved.request;
  } catch { clearBroadcastRecovery(); return null; }
}
export function saveBroadcastRecovery(accountId, request) {
  if (!accountId) throw new Error('Admin-Konto nicht verfügbar. Bitte neu anmelden.');
  sessionStorage.setItem(KEY, JSON.stringify({ accountId: String(accountId), request }));
}
